import { createSelector } from 'reselect';
import { getLocalizedString } from '@synergy/utils';

import { AppState } from '../../store/models/app-state';
import { localesSelector } from './locale-selectors';

const getPositions = (state: AppState) => state.positions.positions;

export const localizedPositionsSelector = createSelector([getPositions, localesSelector], (positions, locales) => {
    return positions.map(position => ({
        id: position.id,
        name: getLocalizedString(locales, position.name),
    }));
});
